import { IComponentsConfig } from '../../_Common/Components/BusinessCollectionComponents/businessCollectionComponents';
import { Fakturahandelsevyer } from './Fakturahandelse/Fakturahandelse';
import { Bokfvervyer } from './Bokforingsverifikationer/Bokfver';
import { Bokfjournalvyer } from './Bokfjournal';
import { Bokfkonteringvyer } from './Bokfkontering/Bokfkontering';
import { initConst } from '../../../../Utils/utils';
import { BokforderVyer } from './Bokforder/Bokforder';
import { BokforderDokumentVyer } from './BokforderDokument/BokforderDokument';
import { BudgetAskandemallarVyer } from './BudgetAskandemallar/BudgetAskandemallarVy';

export const EKVyer = initConst<IComponentsConfig>(() => ({
  EKBokfjournal: Bokfjournalvyer,
  EKBokfkontering: Bokfkonteringvyer,
  EKBokforder: BokforderVyer,
  EKBokforderDokument: BokforderDokumentVyer,
  EKBokfver: Bokfvervyer,
  EKFakturahandelse: Fakturahandelsevyer,
  EKArbetsbudget: BudgetAskandemallarVyer,
}));
